// Same fallback as the backend (Campaign.__str__) and the journey metrics:
// `name` is a manual label nothing fills yet, so most campaigns show the ad
// headline, or its Meta id when the ad has none.
export const campaignLabel = (campaign) =>
  campaign?.name || campaign?.headline || campaign?.external_id || '';

export const PLATFORM_LABELS = {
  meta_ads: 'Meta Ads',
};

export const platformLabel = (platform) => PLATFORM_LABELS[platform] || platform;
